'use strict';

(function ($) {
    $.widget('ui.agSortBox', {
        _create: function () {
            var $element = $(this.element);
            if (!$element.hasClass('form-control-sort-box')) {
                $element.addClass('form-control-sort-box');
            }

            var $targetHidden = $(this.element).find('select.sort-box-target');
            $targetHidden.find('option').prop('selected', true);

            this._on(this.element, {
                'click div.sort-box-up': function (event) {
                    var $source = $(this.element).find('select.sort-box-source');
                    var $selected = $source.find('option:selected');
                    $selected.first().prev().before($selected);

                    var $targetHidden = $(this.element).find('select.sort-box-target');
                    var $targetOptions = $targetHidden.find('option');
                    $.each($selected, function (index, $element) {
                        $.each($targetOptions, function (index2, $element2) {
                            if ($element.value === $element2.value) {
                                $($element2).first().prev().before($($element2));
                            }
                        });
                    });
                }
            });
            this._on(this.element, {
                'click div.sort-box-down': function (event) {
                    var $source = $(this.element).find('select.sort-box-source');
                    var $selected = $source.find('option:selected');
                    $selected.last().next().after($selected);

                    var $targetHidden = $(this.element).find('select.sort-box-target');
                    var $targetOptions = $targetHidden.find('option');
                    $.each($selected, function (index, $element) {
                        $.each($targetOptions, function (index2, $element2) {
                            if ($element.value === $element2.value) {
                                $($element2).last().next().after($($element2));
                            }
                        });
                    });
                }
            });
        }
    });
})($);